import React from "react";
import { Flex, Text, Select, IconButton, TextField } from "@radix-ui/themes";
import { ArrowRightIcon } from "@radix-ui/react-icons";

export const BLOOMREACH_SYNC = "sync";
export const BLOOMREACH_SKIP = "skip";

export function BloomreachSyncSelect({
  value,
  onValueChange,
  disabled = false,
  placeholder = "Select...",
}) {
  const label = value === BLOOMREACH_SYNC ? "Sync" : "Don't sync";
  return (
    <Select.Root
      value={value === BLOOMREACH_SYNC ? BLOOMREACH_SYNC : BLOOMREACH_SKIP}
      onValueChange={onValueChange}
      disabled={disabled}
      style={{ width: "100%", minWidth: 0 }}
    >
      <Select.Trigger placeholder={placeholder} style={{ width: "100%", boxSizing: "border-box" }}>
        <div
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            width: "100%",
          }}
          title={label}
        >
          {label}
        </div>
      </Select.Trigger>
      <Select.Content side="bottom" align="start" sideOffset={4}>
        <Select.Item value={BLOOMREACH_SYNC}>Sync</Select.Item>
        <Select.Item value={BLOOMREACH_SKIP}>Don't sync</Select.Item>
      </Select.Content>
    </Select.Root>
  );
}

const columnGrid = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) 32px minmax(0, 1fr)",
  alignItems: "center",
  columnGap: "8px",
  width: "100%",
};

function ReadOnlyValue({ children, title }) {
  return (
    <Flex
      title={title || children}
      style={{
        width: "100%",
        minWidth: 0,
        height: "32px",
        boxSizing: "border-box",
        backgroundColor: "var(--gray-3)",
        border: "1px solid var(--gray-a7)",
        borderRadius: "var(--radius-2)",
        padding: "0 var(--space-2)",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <Text
        size="2"
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          width: "100%",
          color: "var(--gray-a11)",
        }}
      >
        {children}
      </Text>
    </Flex>
  );
}

function ArrowCell() {
  return (
    <Flex align="center" justify="center">
      <IconButton size="2" variant="ghost" color="gray" style={{ pointerEvents: "none" }}>
        <ArrowRightIcon width="16" height="16" />
      </IconButton>
    </Flex>
  );
}

export function BloomreachMappingHeader() {
  return (
    <div style={columnGrid}>
      <Text size="2" weight="medium">b connect location</Text>
      <span />
      <Text size="2" weight="medium">Bloomreach</Text>
    </div>
  );
}

export function BloomreachColumnGrid({ children }) {
  return <div style={columnGrid}>{children}</div>;
}

export function BloomreachLocationRow({
  loc,
  value,
  onValueChange,
  restaurantName = "",
  onRestaurantNameChange,
  disabled = false,
}) {
  const name = loc.name ?? loc.label ?? "";
  const syncing = value === BLOOMREACH_SYNC;
  return (
    <Flex direction="column" gap="2" style={{ width: "100%" }}>
      <div style={columnGrid}>
        <ReadOnlyValue title={name}>{name}</ReadOnlyValue>
        <ArrowCell />
        <BloomreachSyncSelect value={value} onValueChange={onValueChange} disabled={disabled} />
      </div>
      {syncing ? (
        <div style={columnGrid}>
          <ReadOnlyValue>Restaurant name</ReadOnlyValue>
          <ArrowCell />
          <TextField.Root
            size="2"
            value={restaurantName}
            placeholder={name}
            disabled={disabled}
            style={{ width: "100%" }}
            onChange={(event) => onRestaurantNameChange?.(event.target.value)}
          />
        </div>
      ) : null}
    </Flex>
  );
}
